import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { AccountType, DEFAULT_APPROVAL_LEVELS } from 'util/workflowStatus';

/**
 * The selected paidol's approval-step count, falling back to the account type's
 * default. Components read this and pass it to resolveStatus, which stays pure.
 *
 * Mirrors approval_levels_of in the Amplify and CDK Python: a disabled setting
 * keeps its saved level, so the level only counts while the setting is on. If the
 * two disagreed, chips would render a chain the filters do not offer.
 */
export const useApprovalLevels = (accountType: AccountType): number => {
  const { selectedPaidol } = useAppSelector(selectUserCompanies);
  const settings = selectedPaidol?.approvalWorkflowSettings;
  const fallback = DEFAULT_APPROVAL_LEVELS[accountType];

  if (!settings?.isEnabled) return fallback;

  const levels = settings.approvalLevels;
  if (typeof levels !== 'number' || levels < 0 || levels > 2) return fallback;
  return levels;
};
